export enum treasuryRedemptionFormFields {
  portfolioId = 'portfolioId',
  type = 'type',
  amount = 'amount',
  reason = 'reason',
}
